var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnlyKalinchenko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63006 0H0.0600586V18.85H3.63006V0Z",
    fill: "#A30C33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.97 3.44H10.69L4.5 11.15L10.73 18.86H14.99L8.85 11.15L14.97 3.44Z",
    fill: "#A30C33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6599 3.44H19.3899L13.1899 11.15L19.4199 18.86H23.6899L17.5399 11.15L23.6599 3.44Z",
    fill: "#808285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyKalinchenko);
export default __webpack_public_path__ + "static/media/logo_only_kalinchenko.ad56fd7598306c95071b5be58c100b90.svg";
export { ForwardRef as ReactComponent };